import { ActionReducerMapBuilder } from "@reduxjs/toolkit";

import { IAdminsInitialState } from "./admin.interfaces";

import {
  getListStaffs,
  addStaffAsync,
  updateStaffAsync,
  deleteStaffAsync,
} from "./admin.services";

import { errorInitialValue } from "./admin.slice";

const adminAsyncActions = (
  builder: ActionReducerMapBuilder<IAdminsInitialState>
) => {
  builder.addCase(getListStaffs.pending, (state) => {
    state.loading = "pending";
    state.errors = errorInitialValue;
  });

  builder.addCase(getListStaffs.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listAdmins = action.payload;
  });

  builder.addCase(getListStaffs.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(addStaffAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;

    if (state.listAdmins) {
      state.listAdmins.data.result.push(action.payload.data);
      state.listAdmins.data.count++;
    }
  });

  builder.addCase(updateStaffAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;

    if (state.listAdmins) {
      const index = state.listAdmins.data.result.findIndex(
        (admin) => admin._id === action.payload.data._id
      );
      state.listAdmins.data.result[index] = {
        ...state.listAdmins.data.result[index],
        ...action.payload.data,
      };
    }
  });

  builder.addCase(deleteStaffAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;

    if (state.listAdmins) {
      const index = state.listAdmins.data.result.findIndex(
        (admin) => admin._id === action.meta.arg
      );

      state.listAdmins.data.result.splice(index, 1);
      state.listAdmins.data.count++;
    }
  });
};

export default adminAsyncActions;
